export const fcPlusTgVersion = 'mmt.desktop.rail.default.default.default.rails_fc_tg_together_dweb';
export const irctcEducationPopup = 'mmt.desktop.rail.default.default.default.rails_traveller_irctc_username_edu_popup_Dweb';
export const whyIsThisRequired = 'mmt.desktop.rail.default.default.default.rails_traveller_irctc_edu_witr_Dweb';
export const travellerPageHeader = 'mmt.desktop.rail.default.listing.default.rails_desktop_NewHeader';
export const loggedOutCoupons = 'mmt.desktop.rail.default.default.default.rails_desktop_loggedout_coupons';
export const railsAvlAlertDesktop = 'mmt.desktop.rail.default.detail.default.rails_avl_alert_desktop';
export const avlDepletionDesktop = 'mmt.desktop.rail.default.listing.default.avl_depletion_desktop';
export const urgencyPersuasionBottomsheetDesktop = 'mmt.desktop.rail.default.default.default.urgency_persuasion_bottomsheet_desktop';
export const AB_CONFIG_KEYS = {
  free_cancellation_rails: true,
  railsConfirmationGuaranteeOption: 1,
  rails_travelers_irctc_account_toast: true,
  rails_ayodhya_banner: true,
  'mmt.desktop.rail.default.default.default.rails_fctg_dweb': true,
  'mmt.desktop.rail.default.default.default.rails_fctg_listing': 1,
  [fcPlusTgVersion]: 2,
  [irctcEducationPopup]: 0,
  [whyIsThisRequired]: 0,
  [travellerPageHeader]: false,
  [loggedOutCoupons]: 0,
  [railsAvlAlertDesktop]: 0,
  [avlDepletionDesktop]: 0,
  [urgencyPersuasionBottomsheetDesktop]: false,
};
